<template>
  <div class="organisation relative flex-1">
    <div class="card group cursor-pointer">
      <a
        :onClick="
          () => $router.push(`/organisations/${organisation.repoId}/about`)
        "
        class="flex max-h-50 flex-col k1:flex-row bg-white hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 rounded-r-xl border-gray-200 dark:border-gray-700 shadow-lg"
      >
        <img
          class="object-cover k1:h-52 k1:w-52 w-full h-64"
          :src="organisation.imageUrl || '/placeholder.jpg'"
          :alt="`${organisation.name} logo`"
        />

        <div class="w-full gap-2 flex flex-col p-7 leading-normal">
          <div class="flex justify-between">
            <div class="text-base k15:text-lg font-bold">
              {{ organisation.name }}
            </div>

            <div class="" v-if="!organisation.isPrivate">
              <img
                src="/eqrcmedals_coin_level1.svg"
                class="award w-10 h-10"
                alt=""
              />
            </div>
            <div v-if="organisation.isPrivate">
              <img
                src="/banner.png"
                class="absolute -top-2 -right-2 w-24 h-24"
                alt=""
              />
              <p
                class="text-xs text-white transform rotate-45 absolute top-4 -right-3 w-24 h-24"
              >
                Waiting for approval!
              </p>
            </div>
          </div>
          <div class="flex justify-between">
            <p
              class="w-96 pr-4 text-xs k15:text-sm"
              style="
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ organisation.description }}
            </p>
          </div>
          <div class="flex mt-auto">
            <div class="flex flex-row gap-2 align-center flex-wrap">
              <div
                v-if="principles.includes('communication')"
                class="flex group/principle"
              >
                <div
                  class="h-3 w-5 rounded-full bg-communication self-center"
                ></div>
                <p class="pl-1 text-xs self-center">Communication</p>
                <div class="hidden group-hover/principle:block popUp">
                  <p>
                    Developing Awareness of and Inspiration for Future Quantum
                    Technologies
                  </p>
                </div>
              </div>

              <div
                v-if="principles.includes('diversity')"
                class="flex group/principle"
              >
                <div
                  class="h-3 w-5 rounded-full bg-diversity self-center"
                ></div>
                <p class="pl-1 text-xs self-center">Diversity</p>
                <div class="hidden group-hover/principle:block popUp">
                  <p>
                    Fostering wide access the quantum technology landscape,
                    regardless of background
                  </p>
                </div>
              </div>
              <div
                v-if="principles.includes('standardization')"
                class="flex group/principle"
              >
                <div
                  class="h-3 w-5 rounded-full bg-standardization self-center"
                ></div>
                <p class="pl-1 text-xs self-center">Standardization</p>
                <div class="hidden group-hover/principle:block popUp">
                  <p>
                    The competence framework as a backbone to learning outcomes
                    and industry needs
                  </p>
                </div>
              </div>

              <div
                v-if="principles.includes('representation')"
                class="flex group/principle"
              >
                <div
                  class="h-3 w-5 rounded-full bg-representation self-center"
                ></div>
                <p class="pl-1 text-xs self-center">Representation</p>
                <div class="hidden group-hover/principle:block popUp">
                  <p>The need of the future quantum workforce represented</p>
                </div>
              </div>
              <div
                v-if="principles.includes('innovation')"
                class="flex group/principle"
              >
                <div
                  class="h-3 w-5 rounded-full bg-innovation self-center"
                ></div>
                <p class="pl-1 text-xs self-center">Teaching Innovation</p>

                <div class="hidden group-hover/principle:block popUp">
                  <p>
                    Best practices in education informed by the experts of the
                    entire QTEdu community
                  </p>
                </div>
              </div>

              <div
                v-if="principles.includes('access')"
                class="flex group/principle"
              >
                <div class="h-3 w-5 rounded-full bg-access self-center"></div>
                <p class="pl-1 text-xs self-center">Widening Access</p>
                <div
                  class="hidden group-hover/principle:block hover:hidden popUp"
                >
                  <p>
                    Thigh quality, didactically validated modules made available
                    for free for all
                  </p>
                </div>
              </div>
            </div>
            <div class="ml-auto w-32 self-center">
              <SeeMoreButton></SeeMoreButton>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { capitalize, computed } from "vue";
import SeeMoreButton from "@/components/layout/layoutComponets/SeeMoreButton.vue";
import { useDocument } from "@/composables/useDocument";
import { useDocuments } from "@/composables/useDocuments";

export default {
  name: "Organisation",
  components: { SeeMoreButton },
  props: {
    dataType: {
      type: String,
      required: true,
      validator: (v) => v && capitalize(v) === v,
    },
    organisationId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { filteredDocuments, filter } = useDocuments("Accord");
    filter.value = { parentId: props.organisationId };

    const { organisation } = useDocument(props.dataType, props.organisationId);

    const principles = computed(() =>
      filteredDocuments.value.reduce((list, accord) => {
        const principles = new Set(list);
        accord.principles.forEach((principle) => principles.add(principle));
        return [...principles];
      }, [])
    );

    return {
      organisation,
      principles,
    };
  },
};
</script>

<style scoped></style>
